import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { Options, SeriesOptionsType, ExportingOptions } from 'highcharts';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadMercadoCambiario } from '../../shared/utilities/utilidad-mercado-cambiario';
import { ActivatedRoute } from '@angular/router';
import { MercadoCambiario } from '../../shared/entities/mercado-cambiario';
import { formatNumber } from '@angular/common';
import { HeaderComponent } from '../../shared/header/header.component';
import { interval, Subscription } from 'rxjs';
import { UtilidadExportXLSX } from '../../shared/utilities/utilidad-exportxlsx';
import { Constantes } from '../../shared/constant/constantes';

@Component({
  selector: 'app-mercado-cambiario',
  templateUrl: './mercado-cambiario.component.html',
  styleUrls: ['./mercado-cambiario.component.css'],
  standalone: true,
  imports: [CommonModule, HeaderComponent, HighchartsChartModule]
})
export class MercadoCambiarioComponent implements OnInit {

  private chart?: Highcharts.Chart;
  public chartOptions: Highcharts.Options | null = null;

  public updateFlag: boolean = true;
  public interval: any;
  public festivoUSA: string = '';
  public isHabilidato = true;

  public constante: Constantes = new Constantes();
  public mercadoCambiario: MercadoCambiario = new MercadoCambiario();
  public isTablaMercadoCambiario = false;
  private dataSubscription?: Subscription; // Suscripción para el intervalo
  public urlServidorExport: string = '';

  public showtable: boolean = false;
  public botonTabla: boolean = true;
  public nombreBotonTabla: string = 'Vista tabla';

  constructor(private service: VisualizadorService, private route: ActivatedRoute, private location: Location, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit(): void {
    this.consultarURLServidorExport(this.constante.PROPIEDAD_SERVIDOR_EXPORTACION);
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Dólar hoy intradía datos tiempo real mercado interbancario',
      'Los datos presentados en la gráfica corresponden a los promedios ponderados por montos de las negociaciones ejecutadas y/o registradas a través del sistema de negociación y  registro SetIcap-FX y que son publicados por dicha entidad. Adicionalmente, los datos no son en tiempo real en la medida que su procesamiento requiere de un par de minutos.',
      'intradía, mercado, divisas, dólar, tiempo real, comportamiento del dólar, intradia, gráfica intradía, grafica intradia, comportamiento del dolar durante el dia, comportamiento del dólar durante el día', currentUrl);
    if (isPlatformBrowser(this.platformId)) {
      this.initComponentsHighcharts();
      this.iniciarGrafico();
    }
  }

  private iniciarGrafico() {
    this.service.setWindowScroll(0, 0);
    this.route.url.subscribe(url => {
      if (url.length > 0 && url[0].path === this.constante.ROUTE_TABLAS_PRECONSTRUIDAS || url.length > 0 && url[0].path === this.constante.ROUTE_INFORMACION_SERIE) {
        this.isHabilidato = false;
      } else {
        this.isHabilidato = true;
      }
    });

    this.consultaTablaMercadoCambiario();
    this.service.getFestivoUSA().subscribe({
      next: (data) => {
        this.festivoUSA = data;
      },
      error: (error) => {
        console.log("Error inesperado en getFestivoUSA", error);
      }
    });

    this.service.getMercadoCambiario().subscribe({
      next: (data) => {
        this.initChart(data);
      },
      error: (error) => {
        console.log("Error inesperado en generaListaOptions.getInformacionSeriesAutocomplete", error);
      }
    });
    this.iniciarConsultaDatosTiempoReal();
  }

  iniciarConsultaDatosTiempoReal() {
    this.dataSubscription = interval(9000).subscribe(() => {
      this.consultaTablaMercadoCambiario();
      this.service.getMercadoCambiario().subscribe({
        next: (data) => {
          let listaOptionType: Array<Highcharts.SeriesOptionsType> = new Array();
          const ns = this.getSerieChart(data);
          listaOptionType.push(ns);
          this.chartOptions = {
            series: listaOptionType,
            subtitle: {
              text: this.generaTitulo()
            }
          }
          if (this.chart) {
            this.chart.series[0].setData(data, true);
          }
        },
        error: (error) => {
          console.log("Error inesperado en generaListaOptions.getInformacionSeriesAutocomplete", error);
        }
      });
    });
  }

  private consultaTablaMercadoCambiario() {
    this.service.getTablaMercadoCambiario().subscribe({
      next: (data) => {
        this.mercadoCambiario = data;
        var precioCierre = data.precioCierre;
        var precioPromedio = data.precioPromedio.toString();
        var precioApertura = data.precioApertura;
        var montoTotal = data.montoTotal;
        this.mercadoCambiario.precioCierre = formatNumber(Number(precioCierre), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.precioPromedio = formatNumber(Number(precioPromedio), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.precioApertura = formatNumber(Number(precioApertura), 'co-ES', '1.' + 3 + '-' + 3);
        this.mercadoCambiario.montoTotal = formatNumber(Number(montoTotal), 'co-ES', '1.' + 3 + '-' + 3);
        this.isTablaMercadoCambiario = true;
      },
      error: (error) => {
        console.log("Error inesperado en generaListaOptions.getTablaMercadoCambiario", error);
      }
    });
  }

  public async initChart(data: any[]) {
    if (isPlatformBrowser(this.platformId)) {
      let listaSerieChart: Array<Highcharts.SeriesOptionsType> = new Array();
      const ns = this.getSerieChart(data);
      listaSerieChart.push(ns);
      this.chartOptions = this.getHighchartsOptions(listaSerieChart);
      this.chart = Highcharts.chart('containerMercadoCambiario', this.chartOptions);
    }
  }

  public getHighchartsOptions(listaSeriesChart: any[]): Options {
    var utilMC: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();
    return {
      time: {
          timezone: 'America/Bogota',
      },
      chart: {
        type: 'line',
        borderColor: '#ececec',
        borderWidth: 1,
        events: utilMC.chartEventsOptions(),
        marginBottom: 200,
        style: {
          fontFamily: 'Arial'
        },
        zooming: {
          mouseWheel: {
            enabled: false
          },
          type: 'xy'
        },
        resetZoomButton: {
          position: {
            x: -0,
            y: -0
          }
        }
      },
      title: {
        text: 'Evolución intradía del precio promedio negociado del dólar estadounidense',
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#004677'
        }
      },
      subtitle: {
        text: this.generaTitulo(),
        verticalAlign: 'top',
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#000000',
          textAlign: 'left'
        }
      },
      credits: {
        enabled: false,
        text: ''
      },
      legend: {
        enabled: true,
        floating: false,
        layout: 'horizontal',
        align: 'left',
        verticalAlign: 'top',
        alignColumns: true,
        itemStyle: {
          fontSize: "13px",
          padding: "30px"
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 1
        }
      },
      // PROPIEDADES DEL EJE x
      xAxis: utilMC.xAxisOptions(),
      // PROPIEDADES DEL EJE Y
      yAxis: utilMC.yAxisOptions(),
      series: listaSeriesChart,
      navigation: {
        buttonOptions: {
        },
        menuItemHoverStyle: {
          background: '#ebeced',
          color: 'black'
        }
      },
      tooltip: {
        formatter: function () {
          var fecha = new Date(Number(this.x));
          return 'Hora de la Transacción: ' + fecha.toLocaleTimeString() + '<br/>' + 'Precio promedio ponderado: ' + this.y;
        }
      },
      exporting: this.exportChart(),
      lang: utilMC.langOptions(),
      responsive: {
        rules: [{
          condition: {
            maxWidth: 1000,
            minHeight: 800,
            minWidth: 300
          }
        }]
      }
    }
  }

  private generaTitulo(): string {
    let mc: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();
    var response: string = '';
    response = mc.getTituloActualizado(this.festivoUSA);
    return response;
  }

  private getSerieChart(data: any[]): any {
    let mc: UtilidadMercadoCambiario = new UtilidadMercadoCambiario();
    const datosConvertidos = data.map(item => {
      return [Number(item[0]), Number(item[1])];
    })
    let nombre: string = mc.getDatosSerieJson(data[0][0]);
    let serieChart: SeriesOptionsType = {
      name: nombre,
      color: '#008000',
      type: 'line',
      data: data
    };
    return serieChart;
  }

  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  public exportChart(): Highcharts.ExportingOptions {
    let ue: UtilidadExportXLSX = new UtilidadExportXLSX();
    return {
      enabled: true,
      url: this.urlServidorExport,
      csv: {      
        columnHeaderFormatter: function (item: any, key: any) {
          if (!item || item instanceof Highcharts.Axis) {
            return 'Fecha'
          }
          return 'COP/USD';
        }
      },
      filename: 'intradia',
      chartOptions: { 
        legend: {
          itemWidth: 600,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            fontSize: "10px",
            margin: '30px',
            align: 'center'
          }
        },
        credits: {
          enabled: true,
          position: {
            align: "right",
            verticalAlign: "bottom"
          },
          text: 'Descargado del sistema del Banco de la República ' + new Date().toLocaleString("co-ES")
        }
      },
      menuItemDefinitions: {
        customMenuItem: {
          onclick: () => {
            ue.exportarXLSX(Highcharts.charts[0]);
          },
          text: 'Descargar datos en XLS'
        }
      },
      buttons: {
        contextButton: {
          titleKey: 'Opciones de descarga',
          width: 33,
          height: 32,
          symbol: 'url(/estadisticas-economicas/assets/img/iconos/download.png)',
          symbolY: 15,
          align: 'right',
          verticalAlign: 'top',
          menuItems: [
            'printChart',
            'separator',
            'downloadCSV',
            'customMenuItem',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'separator'
          ]
        }
      }
    }
  }

  private async initComponentsHighcharts() {
    const Highcharts = await import('highcharts');
    await import('highcharts/modules/exporting');
    await import('highcharts/modules/export-data');
    await import('highcharts/modules/offline-exporting');
    await import('highcharts/modules/accessibility');
  }

  private consultarURLServidorExport(llave: string) {
    this.service.consultaParametro(llave).subscribe({
      next: (data) => {
        this.urlServidorExport = data;
      },
      error: (error) => {
        console.log("Error inesperado en consultaParametro", error);
      }
    });
  }

    public toggleView() {
  
      if (Highcharts) {
        const highchartsDataTable = document.querySelector('.highcharts-data-table') as HTMLElement;
        const containerSeriesHighcharts = document.querySelector('.container-series-highcharts') as HTMLElement;
        if (this.showtable) {
          this.nombreBotonTabla = 'Vista tabla';
          highchartsDataTable.style.display = 'none';
          containerSeriesHighcharts.style.display = 'block';
        } else {
          this.nombreBotonTabla = 'Vista gráfica';
          containerSeriesHighcharts.style.display = 'none';
          this.chart!.update({
            exporting: {
              showTable: true // Alternar el valor de showTable
            }
          });
        }
        this.showtable = !this.showtable;
  
      }
    }
}
